import { createServerFn } from "@tanstack/react-start";
import { getCookie } from "@tanstack/react-start/server";
import type { Theme } from "@/store/theme";

/**
 * Server function to get theme from cookies
 * This is called during SSR to prevent theme flash
 */
export const getThemeFromRequest = createServerFn({ method: "GET" }).handler(
  async () => {
    let theme: Theme = "light";

    const themeStorageCookie = getCookie("theme-storage");

    if (themeStorageCookie) {
      try {
        const decoded = decodeURIComponent(themeStorageCookie);
        const themeData = JSON.parse(decoded);

        if (
          themeData.state?.theme &&
          ["light", "dark"].includes(themeData.state.theme)
        ) {
          theme = themeData.state.theme;
        }
      } catch (e) {
        console.warn("Failed to parse theme cookie:", e);
      }
    }

    return theme;
  },
);
